import React from 'react';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';

import { hexToRgb, rgbaStringToObject } from 'Console/utils/colorUtils';

class FormColorPicker extends React.Component {
    constructor(props) {
        super(props);

        const rgb = this.initializeColor(props.initialValue);

        this.state = {
            displayColorPicker: false,
            color: rgb,
        };
    }

    handleClick = () => {
        const { displayColorPicker } = this.state;
        this.setState({ displayColorPicker: !displayColorPicker });
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChange = (color) => {
        const { onChange } = this.props;
        this.setState({ color: color.rgb }, () => onChange(color));
    };

    initializeColor = (colorInput) => {
        const defaultColor = 'rgba(255, 255, 255, 1)';
        const defaultOpacity = '1';

        if (!colorInput) {
            return rgbaStringToObject(defaultColor);
        }

        if (colorInput.startsWith('#')) {
            return {
                ...hexToRgb(colorInput),
                a: defaultOpacity,
            };
        }

        if (colorInput.startsWith('rgba')) {
            return rgbaStringToObject(colorInput);
        }

        return rgbaStringToObject(defaultColor);
    };

    render() {
        const { popupStyles } = this.props;
        const { color, displayColorPicker } = this.state;

        const styles = reactCSS({
            default: {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });

        return (
            <div>
                <div style={styles.swatch} onClick={this.handleClick} role="button" tabIndex="0">
                    <div style={styles.color} />
                </div>
                {displayColorPicker ? (
                    <div style={{ ...styles.popover, ...popupStyles }}>
                        <div style={styles.cover} onClick={this.handleClose} role="generic" />
                        <SketchPicker color={color} onChange={this.handleChange} />
                    </div>
                ) : null}
            </div>
        );
    }
}

export default FormColorPicker;
